import React from 'react';
import {
  Modal,
  ModalHeader,
  ModalBody,
} from 'triider-components';

import styled from 'styled-components';
import { ButtonModal } from '../../Button';

export const Container = styled.div`
  padding: 16px;
`;
export const ModalHeaderCustom = styled(ModalHeader)`
padding: 4vh 0;
`;
export const ContentButtons = styled.div`
  padding: 12px 0 40px;
  display: flex;
  justify-content: center;
`;

function ModalResponsibility({ open, setModalIsOpen }) {
  return (
    <Modal open={open} close={() => setModalIsOpen(false)}>
      <ModalHeaderCustom>
        O que é responsabilidade alterada?
      </ModalHeaderCustom>
      <Container>
        <ModalBody>
          <p>
            Para avaliar a responsabilidade do pedido e determinar se o pagamento deve
            ser feito pelo locador ou locatário, a imobiliária avalia todas as informações
            em conjunto. Considera-se: o tempo de permanência no imóvel, a vistoria de
            entrada do atual inquilino e a de saída do anterior, se o problema foi gerado
            por mau uso ou falta de manutenção preventiva, se é um vício oculto ou problema
            estrutural, sempre considerando o que sugere a lei do inquilinato (Lei 8245/91)
            que rege este tipo de situação. Se a responsabilidade do seu pedido foi alterada
            é porque foi cuidadosamente avaliada e identificada uma ou mais inconformidades
            com a primeira classificação. Em caso de dúvidas, entre em contato com a sua
            imobiliária.
          </p>
        </ModalBody>
        <ContentButtons>
          <ButtonModal onClick={() => setModalIsOpen(false)}>Entendi</ButtonModal>
        </ContentButtons>
      </Container>
    </Modal>
  );
}

export default ModalResponsibility;
